import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app.routes';
import { sharedConfig } from '@serkanyarar/shared';

export const appConfig: ApplicationConfig = {
  ...sharedConfig,
  providers: [...(sharedConfig.providers || []), provideRouter(appRoutes, withComponentInputBinding())]
};
